import { createSlice } from "@reduxjs/toolkit";
import { act } from "react-dom/test-utils";
// import cartItems from '../../cartItems';

const initialState = {
  // titleOfPageStore: "",
  customerStore: null,
  customerInfoModeStore: 1,
  customerGUIDStore: "",
  orderStore: null,
  orderInfoModeStore: 1,
  orderGUIDStore: "",
  orderProductItemStore: [],
  orderItemDetailStore: [],
  orderItemDetailStore_singleValue_ForCopy: null,
  orderItemDetailStoreForPrint: [],
  orderItemsWithMeasurementStore: [],
  orderItemsUniqueStore: [],
  measurementSettings: [],
  //** Product Item */
  productItemAllWithChargeStore: [],

  //** Measurement Detail */
  measurementSettingDetailForEdit: null,
  productItem: null,

  amountStore: 0,
  totalStore: 0,
  isLoadingStore: true,

  //** Login */
  isLogedin: false,
  userFullName: "Miraz",

  //** Product Item list for Item Assign Page */
  orderedItemsToAssign: [],

  //**  Cloth assign to Tailor */
  clothAssignToTailorStore: [],
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    reset: () => initialState,

    //**  Login */
    update_IsLogedIn_Store: (state, action) => {
      state.isLogedin = action.payload;
    },
    update_userFullName_Store: (state, action) => {
      state.userFullName = action.payload;
    },

    //** Customer */
    clearCustomerInfo: (state) => {
      state.customerStore = null;
    },
    addCustomerInfo: (state, action) => {
      state.customerStore = action.payload;
    },
    updateCustomerInfoModeStore: (state, action) => {
      state.customerInfoModeStore = action.payload;
    },
    updateCustomerGUIDStore: (state, action) => {
      state.customerGUIDStore = action.payload;
    },

    //*** Order */
    clearOrder: (state) => {
      state.orderStore = null;
    },
    addOrderInfo: (state, action) => {
      state.orderStore = action.payload;
    },
    updateOrderInfoModeStore: (state, action) => {
      state.orderInfoModeStore = action.payload;
    },
    updateOrderGUIDStore: (state, action) => {
      state.orderGUIDStore = action.payload;
    },
    addOrderItemWithMeasurementsStore: (state, action) => {
      state.orderItemsWithMeasurementStore.push(action.payload);
    },
    removeOrderItemWithMeasurementsStore: (state, action) => {
      const indexNo = action.payload;
      state.orderItemsWithMeasurementStore =
        state.orderItemsWithMeasurementStore.filter(
          (item) => item.indexNo !== indexNo
        );
    },
    addOrderItemUniqueStore: (state, action) => {
      state.orderItemsUniqueStore.push(action.payload);
    },
    removeOrderItemUniqueStore: (state, action) => {
      const indexNo = action.payload;
      state.orderItemsUniqueStore = state.orderItemsUniqueStore.filter(
        (item) => item.indexNo !== indexNo
      );
    },
    updateOrder_IsSMSSent: (state, action) => {
      state.orderStore.isSMSSent = action.payload;
    },

    //**  Order Product Item */
    clearOrderProductItemStore: (state) => {
      state.orderProductItemStore = [];
    },
    assignOrderProductItemListStore: (state, action) => {
      console.log("orderDetail - action.payload" + action.payload);
      state.orderProductItemStore = action.payload;
    },
    addOrderProductItemStoreAtBottom: (state, action) => {
      console.log("orderDetail - action.payload" + action.payload);
      state.orderProductItemStore.splice(
        state.orderProductItemStore.length,
        0,
        action.payload
      );
    },
    removeOrderProductItemStore: (state, action) => {
      const jsonInput = action.payload; // {orderDetailID_GUID: 1}
      const orderDetailID_GUID = jsonInput.orderDetailID_GUID;

      state.orderProductItemStore = state.orderProductItemStore.filter(
        (item) => item.orderDetailID_GUID !== orderDetailID_GUID
      );
    },

    //*** MeasurementSettingsDetail_For_Edit */
    update_MeasurementSettingDetails_forEdit: (state, action) => {
      state.measurementSettingDetailForEdit = action.payload;
    },

    //*** Product Item _For_Edit */
    update_ProductItem_forEdit: (state, action) => {
      state.productItem = action.payload;
    },
    //** Order Item Measurement for Print */

    //** orderItemDetailStoreForPrint */
    assignOrderItemDetailStoreForPrint: (state, action) => {
      state.orderItemDetailStoreForPrint = [];
      state.orderItemDetailStoreForPrint = action.payload;
    },
    clearOrderItemDetailStoreForPrint: (state) => {
      state.orderItemDetailStoreForPrint = [];
    },
    addOrderItemDetailStoreForPrint: (state, action) => {
      console.log(
        "orderItemDetailStoreForPrint - action.payload" + action.payload
      );
      state.orderItemDetailStoreForPrint.splice(0, 0, action.payload);
    },
    removeOrderItemDetailStoreForPrint: (state, action) => {
      const jsonInput = action.payload; // {indexNo: 1}
      const indexNo = jsonInput.indexNo;

      state.orderItemDetailStoreForPrint =
        state.orderItemDetailStoreForPrint.filter(
          (item) => item.indexNo !== indexNo
        );
    },

    //*** Order Item Detail - single value for (Copy Paste) */
    clear_orderItemDetailStore_singleValue_ForCopy: (state) => {
      state.orderItemDetailStore_singleValue_ForCopy = null;
    },

    add_orderItemDetailStore_singleValue_ForCopy: (state, action) => {
      const jsonInput = action.payload; // {copyItem: 1}
      const copyItem = jsonInput.copyItem;

      state.orderItemDetailStore_singleValue_ForCopy = copyItem;

      // console.log(
      //   "orderItemDetailStore_singleValue_ForCopy - action.payload" +
      //     action.payload +
      //     "state.orderItemDetailStore_singleValue_ForCopy " +
      //     state.orderItemDetailStore_singleValue_ForCopy
      // );
    },

    //*** Order Item Detail */
    clearOrderItemDetailStore: (state) => {
      state.orderItemDetailStore = [];
    },
    addOrderItemDetailStore: (state, action) => {
      console.log("orderDetail - action.payload" + action.payload);
      //       let array = ["somevalue", "anothervalue"]
      // let foo = {bar: true}
      // array.unshift(foo);
      state.orderItemDetailStore.splice(0, 0, action.payload);
      //   state.orderItemDetailStore.push(action.payload);
    },
    addOrderItemDetailStoreAtBottom: (state, action) => {
      console.log("orderDetail - action.payload" + action.payload);
      state.orderItemDetailStore.splice(
        state.orderItemDetailStore.length,
        0,
        action.payload
      );
    },
    removeOrderItemDetailStore: (state, action) => {
      const jsonInput = action.payload; // {indexNo: 1}
      const indexNo = jsonInput.indexNo;

      state.orderItemDetailStore = state.orderItemDetailStore.filter(
        (item) => item.indexNo !== indexNo
      );
    },
    updateViewModeOrderItemDetailStore: (state, action) => {
      const jsonInput = action.payload; // {indexNo: 1, modeno:1}

      //***  new code */
      //new code
      const indexValue = state.orderItemDetailStore.findIndex(
        (item) => item.indexNo === jsonInput.indexNo
      );
      let itemDetail = state.orderItemDetailStore.filter(
        (item) => item.indexNo === jsonInput.indexNo
      );
      itemDetail[0].entyOrView = jsonInput.modeno;

      state.orderItemDetailStore = state.orderItemDetailStore.filter(
        (item) => item.indexNo !== jsonInput.indexNo
      );
      // state.orderItemDetailStore.push(itemDetail[0]);
      state.orderItemDetailStore.splice(indexValue, 0, itemDetail[0]);

      //alert("Updated...");

      //**  Old Code */
      // state.orderItemDetailStore.map((orderDetail, i) => {
      //   if (orderDetail.indexNo === jsonInput.indexNo) {
      //     orderDetail.entyOrView = jsonInput.modeno;
      //     //try
      //     // return { ...orderDetail, orderDetail };
      //     // let kk = orderDetail;
      //   }
      // });
    },
    updateOrderDetailGUID_OrderItemDetailStore: (state, action) => {
      const jsonInput = action.payload; // {indexNo:1, orderDetailID_GUID: 1}

      state.orderItemDetailStore.map((orderDetail, i) => {
        if (orderDetail.indexNo === jsonInput.indexNo) {
          orderDetail.orderDetailID_GUID = jsonInput.orderDetailID_GUID;
        }
      });
    },

    //** MeasurementSettings */
    update_MeasurementSettingsStore: (state, action) => {
      state.measurementSettings = action.payload;
    },

    //** Product Item */
    assign_ProductItemWithChargeStore: (state, action) => {
      state.productItemAllWithChargeStore = action.payload;
    },
    //** Product Item To assign stuff */
    add_orderedItemsToAssign_AtBottom: (state, action) => {
      console.log("orderDetail - action.payload" + action.payload);
      state.orderedItemsToAssign.splice(
        state.orderedItemsToAssign.length,
        0,
        action.payload
      );
    },

    pushAtBottom_ProductItemWithChargeStore: (state, action) => {
      console.log("productItem - action.payload" + action.payload);
      state.productItemAllWithChargeStore.splice(
        state.productItemAllWithChargeStore.length,
        0,
        action.payload
      );
    },

    //** cloth assign */
    add_ClothAssignToTailorStoreAtBottom: (state, action) => {
      // console.log("ClothAssignToTailor - action.payload" + action.payload);
      state.clothAssignToTailorStore.splice(
        state.clothAssignToTailorStore.length,
        0,
        action.payload
      );
    },

    assign_ClothAssignToTailorStore: (state, action) => {
      //alert("ClothAssignToTailor - action.payload" + action.payload);
      // console.log("ClothAssignToTailor - action.payload" + action.payload);
      state.clothAssignToTailorStore = action.payload;
    },

    removeClothAssignToTailorStore: (state, action) => {
      const jsonInput = action.payload; // {indexNo: 1}
      const orderDetailID_GUID = jsonInput.orderDetailID_GUID;

      state.clothAssignToTailorStore = state.clothAssignToTailorStore.filter(
        (item) => item.orderDetailID_GUID !== orderDetailID_GUID
      );
    },

    clear_AssignToTailorStore: (state) => {
      state.clothAssignToTailorStore = [];
    },
    // set_TitleOfPageStore: (state, action) => {
    //   state.titleOfPageStore = action.payload;
    // },
  },
});

export const {
  // set_TitleOfPageStore,
  clearCustomerInfo,
  addCustomerInfo,
  updateCustomerInfoModeStore,
  updateCustomerGUIDStore,
  clearOrder,
  addOrderInfo,
  clearOrderProductItemStore,
  assignOrderProductItemListStore,
  addOrderProductItemStoreAtBottom,
  removeOrderProductItemStore,
  updateOrderInfoModeStore,
  updateOrderGUIDStore,

  //** OrderItemDetailStoreForPrint */
  assignOrderItemDetailStoreForPrint,
  clearOrderItemDetailStoreForPrint,
  addOrderItemDetailStoreForPrint,
  removeOrderItemDetailStoreForPrint,

  assignOrderItemsWithMeasurementStoreForPrint,

  //** Measurement copy/paste **********/
  clear_orderItemDetailStore_singleValue_ForCopy,
  add_orderItemDetailStore_singleValue_ForCopy,
  //*** */
  clearOrderItemDetailStore,
  addOrderItemDetailStore,
  addOrderItemDetailStoreAtBottom,
  removeOrderItemDetailStore,
  addOrderItemWithMeasurementsStore,
  removeOrderItemWithMeasurementsStore,
  updateViewModeOrderItemDetailStore,
  updateOrderDetailGUID_OrderItemDetailStore,
  addOrderItemUniqueStore,
  removeOrderItemUniqueStore,
  updateOrder_IsSMSSent,
  //*** */
  update_MeasurementSettingsStore,

  //*** PRoduct Item */
  assign_ProductItemWithChargeStore,
  pushAtBottom_ProductItemWithChargeStore,

  //***  Measurement settings detail for EDIT */
  update_MeasurementSettingDetails_forEdit,
  update_ProductItem_forEdit,

  //** Logged in methods */
  update_IsLogedIn_Store,
  update_userFullName_Store,

  //** assign Item to Stuff */
  add_orderedItemsToAssign_AtBottom,

  //** cloth assign */
  removeClothAssignToTailorStore,
  add_ClothAssignToTailorStoreAtBottom,
  clear_AssignToTailorStore,
  assign_ClothAssignToTailorStore,
} = orderSlice.actions;

export default orderSlice.reducer;
